import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { IModalProps, IModalStyleProps, IModalStyles } from '/druid/Modal.types';
import { ModalBase } from '/druid/Modal.base';
import { getStyles } from '/druid/Modal.styles';

export const Modal: React.FunctionComponent<IModalProps> = styled<IModalProps, IModalStyleProps, IModalStyles>(
  ModalBase,
  getStyles,
  undefined,
  {
    scope: 'Modal',
    fields: ['theme', 'styles', 'enableAriaHiddenSiblings'],
  },
);
